/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosports3ColumnBannersViewProps } from './hosports-3-column-banners';

export default (props: IHosports3ColumnBannersViewProps) => {
    return (
        <h2>{'hosports-three-column-banners-view'}</h2>
    );
};
